import { defineComponent as _defineComponent } from 'vue'
import SliderLimited from "@/components/ui/SliderLimited.vue";
  import { onMounted, ref } from "vue";
  import router from "@/router";
  import {
    CustomerWaitlistDetails,
    CustomerWaitlistDetailsResponse,
  } from "@/types/CustomerWaitlistDetails";
  import store from "@/store";
  import {
    normalizeWaitlistDetails,
    normalizeDataBeforeUpdate,
  } from "@/helpers/customer/normalizer";
  import { LotRangeInterface } from "@/types/LotRangeInterface";
  import { useToast, POSITION } from "vue-toastification";
  import { defaultRange } from "@/static/waitlist";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerWaitlistDetailsEditView',
  setup(__props, { expose: __expose }) {
  __expose();

  const form = ref({} as CustomerWaitlistDetails);
  const ranges: LotRangeInterface = defaultRange;
  const waitlistId = router.currentRoute.value.params.id;
  const isFetching = ref(false);
  const initialData = ref({} as CustomerWaitlistDetails);
  const toast = useToast();

  onMounted(() => {
    fetchDetails();
  });

  function onMyProfile() {
    router.push({ name: "CustomerProfile" });
  }
  function onBack() {
    router.push({ name: "CustomerWaitlistDetailsView" });
  }
  const onCancel = () => {
    form.value = JSON.parse(JSON.stringify(initialData.value));
    router.go(-1);
  };

  function onSave() {
    store
      .dispatch("subscription/updateSubscription", {
        id: waitlistId,
        params: normalizeDataBeforeUpdate(form.value),
      })
      .then(() => {
        toast.success("Data updated successfully", {
          position: POSITION.TOP_LEFT,
        });
      })
      .catch(() => {
        toast.error("Something went wrong", {
          position: POSITION.TOP_LEFT,
        });
      })
      .finally(() => {
        router.go(-1);
      });
  }

  const fetchDetails = () => {
    isFetching.value = true;
    setTimeout(() => {
      store
        .dispatch("subscription/getSubscriptionById", waitlistId)
        .then((response) => {
          setDetails(response.data);
        })
        .finally(() => {
          isFetching.value = false;
        });
    }, 600);
  };

  function setDetails(data: CustomerWaitlistDetailsResponse) {
    initialData.value = normalizeWaitlistDetails(data, "edit");
    form.value = normalizeWaitlistDetails(data, "edit");
  }

const __returned__ = { form, ranges, waitlistId, isFetching, initialData, toast, onMyProfile, onBack, onCancel, onSave, fetchDetails, setDetails, SliderLimited, onMounted, ref, get router() { return router }, get CustomerWaitlistDetails() { return CustomerWaitlistDetails }, get CustomerWaitlistDetailsResponse() { return CustomerWaitlistDetailsResponse }, get store() { return store }, get normalizeWaitlistDetails() { return normalizeWaitlistDetails }, get normalizeDataBeforeUpdate() { return normalizeDataBeforeUpdate }, get LotRangeInterface() { return LotRangeInterface }, get useToast() { return useToast }, get POSITION() { return POSITION }, get defaultRange() { return defaultRange } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})